import { Grid, Skeleton, Typography } from "@mui/material";
import { fieldHeader } from "../../../../../components/fields/field_header";

const OwnerInformationSkeleton = () => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          OWNER INFORMATION:
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Fullname", true)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Title", true)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Email", true)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Owner Mobile #", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Additional Owner Fullname", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("Additional Owner title", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>
          {fieldHeader("Manager or Main Contact Fullname", false)}
        </Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Manager or Main Contact Phone", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Manager or Main Contact Email", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
    </>
  );
};

export default OwnerInformationSkeleton;
